var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfileLogoHistoryOfOperationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 100,
    viewBox: "0 0 74 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.3612 13.5469H55.8689V9.55851C55.8689 8.26812 54.5281 7.6816 53.2988 7.6816H46.7066C45.1423 2.98927 41.2314 0.643094 36.762 0.643094C32.3416 0.468629 28.321 3.31417 26.8173 7.6816H20.3365C19.1074 7.6816 17.8782 8.26812 17.8782 9.55851V13.5469H9.38604C4.35362 13.6033 0.236554 17.7711 0 23.0488V90.2664C0 95.4283 4.46951 99.182 9.38604 99.182H64.3612C69.2774 99.182 73.7468 95.4283 73.7468 90.2664V23.0491C73.5105 17.7711 69.3932 13.6033 64.3612 13.5469ZM22.3476 12.374H28.4932C29.566 12.2365 30.4277 11.3797 30.6163 10.2624C31.278 7.23702 33.8062 5.06532 36.762 4.98359C39.6903 5.07677 42.1804 7.25522 42.7957 10.2624C42.9961 11.4184 43.9147 12.2862 45.0305 12.374H51.3996V21.7587H22.3476V12.374ZM69.2774 90.2669C69.2774 92.8476 66.8193 94.4899 64.3612 94.4899H9.38604C6.92775 94.4899 4.46951 92.8476 4.46951 90.2669V23.0491C4.69751 20.3627 6.8174 18.2887 9.38604 18.2395H17.878V24.2223C17.9961 25.5367 19.0804 26.5199 20.3363 26.4512H53.2988C54.5777 26.5246 55.6961 25.5549 55.8689 24.2223V18.2393H64.3606C66.9292 18.2887 69.0492 20.3625 69.2774 23.0488V90.2669Z",
    fill: "url(#paint0_linear_1239_11243)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2712 53.08C27.433 52.1524 26.0416 52.1 25.1424 52.9627L17.9912 60.1185L14.9743 56.834C14.1361 55.9062 12.7447 55.8541 11.8455 56.7164C10.98 57.6688 10.98 59.1666 11.8455 60.1185L16.4267 65.0452C16.8232 65.5117 17.396 65.7692 17.991 65.7496C18.5804 65.7406 19.1427 65.4876 19.5552 65.0452L28.2707 56.3647C29.1348 55.5325 29.1926 54.1225 28.3997 53.2156C28.3591 53.1682 28.3161 53.1231 28.2712 53.08Z",
    fill: "url(#paint1_linear_1239_11243)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3412 58.1229H34.6417C33.4075 58.1229 32.407 59.1733 32.407 60.469C32.407 61.7646 33.4075 62.8151 34.6417 62.8151H60.3412C61.5753 62.8151 62.5759 61.7646 62.5759 60.469C62.5759 59.1733 61.5753 58.1229 60.3412 58.1229Z",
    fill: "url(#paint2_linear_1239_11243)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2712 34.31C27.433 33.3824 26.0416 33.3301 25.1424 34.1928L17.9912 41.3485L14.9743 38.0637C14.1361 37.1362 12.7447 37.0839 11.8455 37.9465C10.98 38.8986 10.98 40.3964 11.8455 41.3485L16.4267 46.2754C16.8232 46.7416 17.396 46.9994 17.991 46.9794C18.5804 46.9706 19.1427 46.7176 19.5552 46.2754L28.2707 37.5947C29.1348 36.7626 29.1926 35.3525 28.3997 34.4456C28.3591 34.3982 28.3161 34.3531 28.2712 34.31Z",
    fill: "url(#paint3_linear_1239_11243)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3412 39.354H34.6417C33.4075 39.354 32.407 40.4044 32.407 41.7002C32.407 42.996 33.4075 44.0464 34.6417 44.0464H60.3412C61.5753 44.0464 62.5759 42.996 62.5759 41.7002C62.5759 40.4044 61.5753 39.354 60.3412 39.354Z",
    fill: "url(#paint4_linear_1239_11243)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2712 71.8489C27.433 70.9212 26.0416 70.8691 25.1424 71.7314L17.9912 78.8872L14.9743 75.6027C14.1361 74.6749 12.7447 74.6228 11.8455 75.4856C10.98 76.4375 10.98 77.9353 11.8455 78.8872L16.4267 83.8145C16.8232 84.2803 17.396 84.5385 17.991 84.5183C18.5804 84.5094 19.1427 84.2563 19.5552 83.8145L28.2707 75.1334C29.1348 74.3014 29.1926 72.8915 28.3997 71.9844C28.3591 71.9374 28.3161 71.8921 28.2712 71.8489Z",
    fill: "url(#paint5_linear_1239_11243)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3412 76.8935H34.6417C33.4075 76.8935 32.407 77.944 32.407 79.2396C32.407 80.5353 33.4075 81.5857 34.6417 81.5857H60.3412C61.5753 81.5857 62.5759 80.5353 62.5759 79.2396C62.5759 77.944 61.5753 76.8935 60.3412 76.8935Z",
    fill: "url(#paint6_linear_1239_11243)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1239_11243",
    x1: 62.8037,
    y1: 108.401,
    x2: 62.8037,
    y2: -6.54886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1239_11243",
    x1: 62.8037,
    y1: 108.401,
    x2: 62.8037,
    y2: -6.54886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1239_11243",
    x1: 62.8037,
    y1: 108.401,
    x2: 62.8037,
    y2: -6.54886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1239_11243",
    x1: 62.8037,
    y1: 108.401,
    x2: 62.8037,
    y2: -6.54886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1239_11243",
    x1: 62.8037,
    y1: 108.401,
    x2: 62.8037,
    y2: -6.54886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1239_11243",
    x1: 62.8037,
    y1: 108.401,
    x2: 62.8037,
    y2: -6.54886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1239_11243",
    x1: 62.8037,
    y1: 108.401,
    x2: 62.8037,
    y2: -6.54886,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileLogoHistoryOfOperationIcon);
export default __webpack_public_path__ + "static/media/profile_logo_history-of-operation_icon.f142ef3aa8a7752013a950ce9aa90d3b.svg";
export { ForwardRef as ReactComponent };